import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid2 } from "@mui/material";
import Typography from "@mui/material/Typography";
import TextAreaEditor from "components/common/TextAreaEditor";
import { assertArray, assertString, validateMultipleEmails } from "core/validation";

import SendIcon from "@mui/icons-material/Send";
import Paper from "@mui/material/Paper/Paper";
import log from "loglevel";
import Draggable from "react-draggable";
import { shallowEqual, useSelector } from "react-redux";

import { PerformanceTextArea } from "components/common/PerformanceInput";
import { selectorCurrentUserEmail } from "components/login/logic/actions";

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title-email" cancel={"[class*='MuiDialogContent-root']"}>
            <Paper {...props} />
        </Draggable>
    );
}

function EmailDialog(props) {
    const userEmail = useSelector(selectorCurrentUserEmail, shallowEqual);
    const emailSign = useSelector((state) => state.login.user.emailSign);
    const { ccList, primaryList, onClose, plusCcBtn, onSend } = props;
    const [toValue, setToValue] = useState("");
    const [ccValue, setCCValue] = useState("");
    const [subject, setSubject] = React.useState(props.subject);
    const [ccValid, setCCValid] = useState(true);
    const [toValid, setToValid] = useState(true);
    const [bcc, setBcc] = useState(true);

    useEffect(() => {
        log.debug(ccList, primaryList);
        if (assertArray(ccList)) {
            setCCValue(ccList.map((item) => item.addresses.map((address) => address.email).join("; \n")).join("; \n"));
        }
        if (assertArray(primaryList)) {
            const emails = primaryList.filter((item) => assertString(item.email)).map((item) => item.email);
            setToValue(assertArray(emails) ? emails.join("; \n") : "");
        }
    }, [ccList, primaryList]);

    function handleClose() {
        onClose();
    }
    function validateCC(e) {
        const value = e.target.value;
        setCCValid(assertString(value) ? validateMultipleEmails(value) : true);
    }
    function validateTo(e) {
        const value = e.target.value;
        setToValid(validateMultipleEmails(value));
    }
    function handleCcChange(e) {
        setCCValue(e.target.value);
    }
    function handleSubject(e) {
        setSubject(e.target.value);
    }
    function handleToChange(e) {
        setToValue(e.target.value);
    }

    function handleOnSend() {
        if (ccValid && toValid) {
            const message = {
                to: toValue,
                cc: ccValue,
                subject: subject,
                bcc: bcc,
                emailSign: emailSign,
                body: bodyRef.current.getValue(),
            };
            onSend(message);
        }
    }
    function handleBccEnableChange(e) {
        setBcc(e.target.checked);
    }

    const bodyRef = useRef(null);

    return (
        (<Dialog
            open={true}
            maxWidth={"md"}
            PaperComponent={PaperComponent}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle style={{ cursor: "move" }} id={"draggable-dialog-title-email"}>
                <span style={{ fontSize: 16 }}>
                    <AttachFileIcon /> Send AdvertisingReport.pdf
                </span>
                <div className={"atsFloatRight"}>
                    <Button onClick={handleClose} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        style={{ marginLeft: 10 }}
                        onClick={handleOnSend}
                        variant="outlined"
                        color="secondary"
                        endIcon={<SendIcon />}
                    >
                        Send
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid2 container spacing={2}>
                    <Grid2 justify={"flex-end"} size={1}>
                        <Typography variant={"subtitle1"}>From </Typography>
                    </Grid2>
                    <Grid2 size={10}>
                        <TextField
                            label={null}
                            value={userEmail}
                            error={!toValid}
                            disabled
                            onChange={() => {}}
                            variant="outlined"
                        />
                    </Grid2>
                    <Grid2 size={1}></Grid2>
                    <Grid2 justify={"flex-end"} size={1}>
                        <Typography variant={"subtitle1"}>To </Typography>
                    </Grid2>
                    <Grid2 size={10}>
                        <PerformanceTextArea
                            label={null}
                            className={`ats-autoTextarea ${!toValid ? "ats-autoTextareaError" : ""}`}
                            value={toValue}
                            error={!toValid}
                            onChange={handleToChange}
                            variant="outlined"
                            onBlur={validateTo}
                            helperText="Incorrect entry."
                        />
                    </Grid2>
                    <Grid2 size={1}></Grid2>
                    <Grid2 justify={"flex-end"} size={1}>
                        <Typography variant={"subtitle1"}>CC </Typography>
                    </Grid2>
                    <Grid2 size={10}>
                        <PerformanceTextArea
                            label={null}
                            className={`ats-autoTextarea ${!ccValid ? "ats-autoTextareaError" : ""}`}
                            error={!ccValid}
                            value={ccValue}
                            onChange={handleCcChange}
                            onBlur={validateCC}
                            helperText="Incorrect entry."
                        />
                    </Grid2>
                    <Grid2 justify={"flex-start"} size={1}>
                        {plusCcBtn}
                    </Grid2>
                    <Grid2 container  justify={"flex-start"} alignItems={"center"} size={1}>
                        <Typography variant={"subtitle1"} display="inline">
                            BCC Me{" "}
                        </Typography>
                    </Grid2>
                    <Grid2 size={10}>
                        <FormControlLabel
                            control={<Switch checked={bcc} onChange={handleBccEnableChange} />}
                            label=""
                        />
                    </Grid2>
                    {}
                    <Grid2 size={1}></Grid2>
                    <Grid2 justify={"flex-end"} size={1}>
                        <Typography variant={"subtitle1"}>Subject </Typography>
                    </Grid2>
                    <Grid2 size={10}>
                        <TextField label={null} value={subject} onChange={handleSubject} variant="outlined" />
                    </Grid2>
                    <Grid2 size={1}></Grid2>

                    <Grid2 size={12}>
                        <TextAreaEditor
                            ref={bodyRef}
                            addEmptyBlocks={3}
                            rootStyle={{ paddingBottom: 10, marginTop: 5 }}
                            defaultValue={"<p><br/></p><p><br/></p><p><br/></p><p>" + emailSign + "</p>"}
                        />
                    </Grid2>
                </Grid2>
            </DialogContent>
        </Dialog>)
    );
}

export default EmailDialog;

EmailDialog.propTypes = {
    ccList: PropTypes.string.isRequired,
    primaryList: PropTypes.string.isRequired,
    subject: PropTypes.string,
};
